<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="关联订单">
                  <el-input v-model="queryForm.purchaseOrderNo" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算状态">
                  <el-select v-model="queryForm.settlementStatus" clearable>
                    <el-option label="待结算" :value="0"></el-option>
                    <el-option label="待付款" :value="1"></el-option>
                    <el-option label="已结算" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算单号">
                  <el-input v-model="queryForm.settlementOrderNo" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="showForm">新增</el-button>
      <div class="upload-btn">
        <el-button type="primary" icon="el-icon-upload">导入</el-button>
        <input @change="changeFile" accept=".xls,.xlsx" type="file" />
      </div>
      <el-button type="text" @click="downloadTemplate">下载文件模板</el-button>
    </div>
    
    <el-table :data="tableData">
      <el-table-column prop="vendorAliasName" label="买手店别名"></el-table-column>
      <el-table-column prop="purchaseOrderNo" label="关联订单号"></el-table-column>
      <el-table-column prop="settlementOrderNo" label="结算单号"></el-table-column>
      <el-table-column prop="amount" label="金额"></el-table-column>
      <el-table-column prop="paymentDescription" label="款项说明"></el-table-column>
      <el-table-column prop="settlementTimestamp" label="结算日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.settlementTimestamp) }}
        </template>
      </el-table-column>
      <el-table-column prop="createdTimestamp" label="创建日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdTimestamp) }}
        </template>
      </el-table-column>
      <el-table-column label="结算状态">
        <template slot-scope="scope">
          <span v-if="scope.row.settlementStatus === 0">待结算</span>
          <span v-if="scope.row.settlementStatus === 1">待付款</span>
          <span v-if="scope.row.settlementStatus === 2">已结算</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.settlementStatus === 0" @click="removeItem(scope.row)">删除</el-link>
          <el-link type="primary" class="ml10" v-if="scope.row.settlementStatus === 0" @click="editItem(scope.row)">编辑</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="`${isEdit ? '编辑' : '新增'}履约扣款`" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item prop="vendorId" label="买手店" :rules="[{ required: true, message: '请选择买手店' }]">
          <el-select v-model="form.vendorId" filterable :disabled="isEdit">
            <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="币种">{{ form.vendorId ? vendorUnitMap[form.vendorId] : '' }}</el-form-item>
        <el-form-item prop="purchaseOrderNo" label="关联订单" :rules="[{ required: true, message: '请输入关联订单' }]">
          <el-input v-model="form.purchaseOrderNo" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item prop="amount" label="金额" :rules="[{ required: true, message: '请输入金额' }]">
          <el-input type="number" v-model.number="form.amount" max="99999999" min="-99999999"></el-input>
        </el-form-item>
        <el-form-item prop="settlementTimestamp" label="结算日期" :rules="[{ required: true, message: '请选择结算日期' }]">
          <el-date-picker
            v-model="form.settlementTimestamp"
            type="date"
            :editable="false"
            :clearable="false"
            value-format="timestamp"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions';
import Client from "@/utils/client.js";
import { fileUpload } from '../../../api/merchants_cn';
import {
  getNotOrderSettlementList,
  saveNotOrderSettlement,
  delNotOrderSettlement,
  importNotOrderSettlement,
} from "./api";
import {
  queryVendorList,
} from '../../../api/mapping_cn';

export default {
  components: {
  },
  data() {
    return {
      vendorList: [],
      vendorUnitMap: {},
      queryForm: {
        vendorId: null,
        purchaseOrderNo: null,
        settlementStatus: null,
        settlementOrderNo: null,
        channel: 2,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      isEdit: false,
      form: {
        nonOrderSettlementId: null,
        vendorId: null,
        purchaseOrderNo: null,
        amount: null,
        settlementTimestamp: null,
        channel: 2,
      },
    };
  },
  mounted() {
    queryVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
        const map = {};
        res.data.data.forEach(item => {
          map[item.vendorId] = item.originalPriceUnit;
        });
        this.vendorUnitMap = map;
      }
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.purchaseOrderNo = null;
      this.queryForm.settlementStatus = null;
      this.queryForm.settlementOrderNo = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getNotOrderSettlementList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    showForm() {
      this.isEdit = false;
      this.form.nonOrderSettlementId = null;
      this.form.vendorId = null;
      this.form.purchaseOrderNo = null;
      this.form.amount = null;
      this.form.settlementTimestamp = Date.now();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.isEdit = true;
      this.form.nonOrderSettlementId = row.nonOrderSettlementId;
      this.form.vendorId = row.vendorId;
      this.form.purchaseOrderNo = row.purchaseOrderNo;
      this.form.amount = row.amount;
      this.form.settlementTimestamp = row.settlementTimestamp;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            saveNotOrderSettlement(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success('提交成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch(() => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    removeItem(row) {
      this.$confirm(`确认删除吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delNotOrderSettlement({
          nonOrderSettlementId: row.nonOrderSettlementId
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.message || '操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.xls .xlsx格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        importNotOrderSettlement({
          fileUrl: res.url,
          channel: 2,
        }).then(res => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$message.success('导入任务已创建，请去“任务管理”查看结果');
            this.dialogVisible = false;
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        }).catch(() => {
          this.fullscreenLoading = false;
        })
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    downloadTemplate() {
      downloadUrlFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/1ce42743-1e4f-42d0-a9a6-440e66ce50d6template.xlsx');
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.upload-btn {
  position: relative;
  display: inline-block;
  margin: 0 10px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
</style>
